import React from 'react';
import './toggle.scss';
import { ToggleSwitch } from '../toggle-switch/toggle-switch';

interface ToggleProps {
  label: string;
  id: string;
  onChange?: (data: { name: string; required: boolean; value: boolean }) => void;
  defaultValue: boolean;
}

export function Toggle(props: ToggleProps) {
  const handleChange = (data: { name: string; required: boolean; value: boolean }) => {
    props.onChange && props.onChange(data);
  };

  return (
    <div className="toggle-container">
      <div className="toggle-header">{props.label}</div>
      <div>
        <ToggleSwitch id={props.id} onChangeEmit={handleChange} defaultChecked={props.defaultValue} />
      </div>
    </div>
  );
}
